<template>
  <div
    v-if="graphItems.length > 0"
    class="graph-table-container"
  >
    <GraphTable
      id="sidebar-graph-table"
      :items="graphItems"
      class="mt-4 sidebar-graph-table"
      :show-percentages="true"
    />
    <p
      class="total"
      data-cy="total-string"
    >
      {{ totalLabel }}{{ totalString }}
    </p>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import GraphTable from '@/components/public/GraphTable/GraphTable.vue'

const components = {
  GraphTable,
}

export interface GraphItem {
  title: string,
  value: number,
  formatted: string,
  color: string,
  percentage: number,
}

@Component({ components })
export default class GraphTableTotal extends Vue {
  get hidePiechartOnZeroNegative () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.appConfig.hidePiechartOnZeroNegative
  }

  get fieldValueForColumn () {
    return this.$typedStore.visualisationData.fieldValueForColumn
  }

  get formatValueByColumn () {
    return this.$typedStore.visualisationData.formatValueByColumn
  }

  get name () {
    return this.$typedStore.visualisationApp.name
  }

  get piechartItems () {
    return this.$typedStore.visualisationApp.piechartItems
  }

  get total () {
    return this.piechartItems
      .reduce((acc, cur) => {
        return acc + this.fieldValueForColumn(cur.column)
      }, 0)
  }

  get piechartTotalLabel () {
    if (this.$typedStore.activeVisualisation.visualisationStore.app.config.appConfig.piechartTotalLabel) {
      return this.$typedStore.activeVisualisation.visualisationStore.app.config.appConfig.piechartTotalLabel
    } else {
      return this.$typedStore.activeVisualisation.visualisationStore.app.config.appConfig.totalStringLabel
    }
  }

  get totalLabel () {
    return this.piechartTotalLabel ? `${this.piechartTotalLabel}: ` : ''
  }

  get totalString () {
    // Assumes all items are the same unit as the first item
    const column = this.piechartItems[0].column
    return this.formatValueByColumn(column, this.total)
  }

  get graphItems (): GraphItem[] {
    return this.piechartItems
      .map((item) => {
        const title = this.name(item.column)
        const value = this.fieldValueForColumn(item.column)
        const formatted = this.formatValueByColumn(item.column)
        return {
          title: title,
          value: value,
          formatted,
          color: item.color,
          percentage: this.total === 0 ? 0 : value / this.total,
        }
      })
      .filter((item) => {
        if (this.hidePiechartOnZeroNegative) return item.value > 0
        else return true
      })
  }
}
</script>
